export default function Ornament({ className = "" }) {
  return (
    <div className={`flex items-center justify-center gap-4 ${className}`} aria-hidden="true">
      <span className="orn-line" />
      <svg width="32" height="14" viewBox="0 0 32 14" fill="none" className="text-brand-gold flex-shrink-0">
        <path d="M16 0 L20 7 L16 14 L12 7 Z" fill="currentColor" />
        <circle cx="3" cy="7" r="1.2" fill="currentColor" />
        <circle cx="29" cy="7" r="1.2" fill="currentColor" />
      </svg>
      <span className="orn-line" />
    </div>
  );
}
